import React, {Component, ErrorInfo, ReactNode} from 'react'

type Props = {
  children: ReactNode
  fallback?: ReactNode
}

type State = {
  hasError: boolean
  error: Error | null
}

export class ProcurementErrorBoundary extends Component<Props, State> {
  state: State = {hasError: false, error: null}

  static getDerivedStateFromError(error: Error): State {
    return {hasError: true, error}
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Procurement page render error:', error, errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      return (
        <div className='alert alert-danger m-6'>
          <h4 className='alert-heading mb-3'>Unable to display Quotation Management.</h4>
          <p className='mb-0'>Please refresh or return to Procurement.</p>
        </div>
      )
    }

    return this.props.children
  }
}
